<template>
  <div class="container text-center mt-3" style="height: 87%">
    <h1> Echec de la connexion </h1>
    <br>
    <div>
      <label>Cliquer <button class="btn btn-link p-0 mb-1" @click="logout()">ici</button> pour réessayer</label> <br>
      <label> 
        Si le problème persiste vous pouvez envoyer un mail à l'adresse <b> {{ hospitalMail }} </b> afin d'exercer vos droits.
      </label>
    </div>
  </div>
</template>

<script>
import AuthService from "../../services/auth.service";
export default {
  name: 'Forbidden',
  data() {
      return {
        hospitalMail: process.env.VUE_APP_HOSPITAL_MAIL
      };
  },

  mounted() {
  },

  methods: {
    logout() {
      if(AuthService.isAuthenticated()){
        AuthService.logout();
      } else {
        this.$router.push({ name: 'Login' });
      }
    },
  }
};
</script>